import { PayloadAction, createSlice } from '@reduxjs/toolkit';

export interface applicationTypeInitialStateI {
  totalPages: number;
  totalRecords: number;
}

const initialState: applicationTypeInitialStateI = {
  totalPages: 0,
  totalRecords: 0
};

export const applicationTypeSlice = createSlice({
  name: 'applicationTypeSlice',
  initialState,
  reducers: {
    setApplicationTypeTotalPAges: (
      state: applicationTypeInitialStateI,
      actions: PayloadAction<applicationTypeInitialStateI>
    ) => {
      state.totalPages = actions.payload.totalPages;
      state.totalRecords = actions.payload.totalRecords;
    }
  }
});
